import apiClient from "./apiClient";
import { cleanObject } from "../utils/commonutils";
import { fieldsConfig } from "../utils/fieldsConfig";

const Url = `/paymentrecovery`;

const toPayload = (data) => {
  const rawBody = {};
  Object.keys(fieldsConfig).forEach((key) => {
    rawBody[key] = data[key];
  });
  const customerId =
    data?.customerId?._id || (typeof data?.customerId === "string" ? data.customerId : "");
  if (customerId) rawBody.customerId = customerId;
  if (data?.customerId?.companyName) rawBody.applicantName = data.customerId.companyName;
  return cleanObject(rawBody);
};

export const getPaymentRecoveries = async (props, currentPage, rowsPerPage, searchText) => {
  try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;
    if (searchText && searchText.trim() !== "") {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPaymentRecoveryDetail = async (payload, props) => {
  try {
    if (!payload?.recoveryId) return false;
    const response = await apiClient.get(`${Url}/${payload.recoveryId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const addPaymentRecovery = async (props, data) => {
  try {
    const response = await apiClient.post(Url, toPayload(data));
    return response.data;
  } catch (error) {
    return error;
  }
};

export const editPaymentRecovery = async (props, data, editId) => {
  try {
    const response = await apiClient.put(`${Url}?paymentRecoveryId=${editId}`, toPayload(data));
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deletePaymentRecovery = async (recoveryId, props) => {
  try {
    if (!recoveryId) return false;
    return await apiClient.delete(`${Url}?paymentRecoveryId=${recoveryId}`);
  } catch (error) {
    return error;
  }
};
